import { Inject } from 'inversify-props'
import { ProdutoMarketplace } from '@/models'
import type { MarketplaceServiceAdapter } from './adapter'

export class UpdateProdutoMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	update = async (produto: ProdutoMarketplace): Promise<ProdutoMarketplace> =>
		this.marketplaceAdapter.updateProduto(produto)

	create = async (produto: ProdutoMarketplace): Promise<ProdutoMarketplace> =>
		this.marketplaceAdapter.createProduto(produto)
}